/* eslint-disable import/first */

import Amplify, { Auth } from 'aws-amplify'
import { DEFAULT_ENDPOINT, AUTH_ENDPOINT, MOCKAPI_ENDPOINT, VAULT_ENDPOINT } from './constants'
//NOTE: Amplify configuration

Amplify.configure({
  Auth: {
    region: process.env['REACT_APP_COGNITO_REGION'],
    userPoolId: process.env['REACT_APP_COGNITO_USER_POOL_ID'],
    userPoolWebClientId: process.env['REACT_APP_COGNITO_USER_POOL_WEBCLIENT_ID'],
    cookieStorage: {
      domain: window.location.hostname === 'localhost' ? 'localhost' : process.env['REACT_APP_HOST_NAME'],
      secure: false,
      path: '/',
      expires: 365,
    },
  },
  API: {
    endpoints: [
      {
        name: DEFAULT_ENDPOINT,
        endpoint: process.env['REACT_APP_BACKEND_BASE_URL'],
        custom_header: async () => {
          const session = await Auth.currentSession()
          const idToken = session.getIdToken()
          const jwtToken = idToken.getJwtToken()
          return { Authorization: jwtToken }
        },
      },
      {
        name: AUTH_ENDPOINT,
        endpoint: process.env['REACT_APP_BACKEND_BASE_AUTH_URL'],
        custom_header: async () => {
          const session = await Auth.currentSession()
          const idToken = session.getIdToken()
          const jwtToken = idToken.getJwtToken()
          return { Authorization: jwtToken }
        },
      },
      {
        name: VAULT_ENDPOINT,
        endpoint: process.env['REACT_APP_VAULT_API_URL'],
        custom_header: async () => {
          const session = await Auth.currentSession()
          const idToken = session.getIdToken()
          const jwtToken = idToken.getJwtToken()
          return { Authorization: jwtToken }
        },
      },
      {
        name: MOCKAPI_ENDPOINT,
        endpoint: process.env['REACT_APP_MOCK_API_URL'],
        custom_header: async () => {
          const session = await Auth.currentSession()
          const idToken = session.getIdToken()
          const jwtToken = idToken.getJwtToken()
          return { Authorization: jwtToken }
        },
      },
    ],
  },
})

import ServerApi from './ServerApi'
import * as VaultAPI from './VaultApi'

export { VaultAPI }

export default new ServerApi()
